/*
 * @Author: your name
 * @Date: 2020-10-18 20:11:09
 * @LastEditTime: 2020-11-18 15:22:15
 * @LastEditors: wutt
 * @Description: In User Settings Edit
 * @FilePath: /portal/src/model/DataSource/OLLayerTypeJs.js
 */
export const OLLayerType =
{
    layer_Vector: "layer_Vector",

    layer_Heatmap: "layer_Heatmap",

    layer_VectorTile: "layer_VectorTile",

    layer_Tile:"layer_Tile",
    layer_echarts:"layer_echarts",


    /**
     * 获取图层类型
     * @param {*} olLayer 
     */
    getLayerType(olLayer) {
        let layerType = null;

        if (!olLayer) return layerType;

        if (olLayer instanceof ol.layer.Heatmap) {
            layerType = OLLayerType.layer_Heatmap;
        }
        else if (olLayer instanceof ol.layer.VectorTile) {
            layerType = OLLayerType.layer_VectorTile;
        }
        else if (olLayer instanceof ol.layer.Vector) {
            layerType = OLLayerType.layer_Vector;
        }
        
        return layerType;
    }


}